import { render, staticRenderFns } from "./InvestigationSequences.vue?vue&type=template&id=4520eb79&scoped=true&"
import script from "./InvestigationSequences.vue?vue&type=script&lang=js&"
export * from "./InvestigationSequences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520eb79",
  null
  
)

export default component.exports